export default ({ app }, inject) => {
  inject('findify', () => ({
    search: () => null
  }))

  inject('findifyAnalytics', () => ({
    sendEvent: () => null
  }))
}
